import { make } from 'vuex-pathify'
import dottie from 'dottie'
import LunrWrapper from '@/LunrWrapper'
import { api } from '@/api'

/**
 * Function to sort alphabetically an array of objects by some specific key.
 *
 * @param {String} property Key of the object to sort.
 */
function dynamicSort(property) {
  var sortOrder = 1

  if (property[0] === '-') {
    sortOrder = -1
    property = property.substr(1)
  }

  return function(a, b) {
    const num = Number.isInteger(a[property]) && Number.isInteger(b[property])
    if (sortOrder === -1) {
      if (num) return b[property] - a[property]
      return b[property].localeCompare(a[property])
    } else {
      if (num) return a[property] - b[property]
      return a[property].localeCompare(b[property])
    }
  }
}

const state = {
  industries: [],
  sortKey: 'name',
  sortOrder: 'ascend',
  searchTerm: '',
  lunr: null
}

const getters = {
  ...make.getters(state),

  sortedList(state, getters) {
    const sortProperty =
      state.sortOrder === 'ascend' ? state.sortKey : `-${state.sortKey}`
    return getters.filteredList.sort(dynamicSort(sortProperty))
  },

  filteredList: state =>
    state.lunr ? state.lunr.query(state.searchTerm) : state.industries
}

const mutations = {
  ...make.mutations(state),
  read(state, industries) {
    state.industries = industries
    state.lunr = new LunrWrapper(industries, ['name'])
  }
}

const actions = {
  async list({ commit }) {
    try {
      const response = await api.get('/industries')
      const industries = dottie.get(response, 'data.industries', [])
      commit('read', industries)
    } catch (e) {
      commit('SET_INDUSTRIES', [])
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
